export enum UserRoles {
    admin = 1,
    customer = 2,
    service = 3,
    manager = 4,
    adminLite = 5,
}
